import { supabase } from "@/integrations/supabase/client";

export const rephraseGoalWithAI = async (goal: string): Promise<string | null> => {
  try {
    const { data, error } = await supabase.functions.invoke("rephrase-goal", {
      body: { goal },
    });

    if (error) {
      console.error("Error calling rephrase-goal:", error);
      return null;
    }

    return data?.rephrased || null;
  } catch (e) {
    console.error("Failed to rephrase goal with AI:", e);
    return null;
  }
};
